module.exports = __webpack_public_path__ + "img/generico.440e266a.png";